import { setup } from "xstate";

export enum VitalsCategoryState {
  Dashboard = "dashboard",
  BloodPressure = "bloodPressure",
  BloodPressureForm = "bloodPressureForm",
  HeartRate = "heartRate",
  HeartRateForm = "heartRateForm",
  BreathingRate = "breathingRate",
  BreathingRateForm = "breathingRateForm",
}

export const vitalsCategoryEventNames = {
  OPEN_BLOOD_PRESSURE: "OPEN_BLOOD_PRESSURE",
  OPEN_HEART_RATE: "OPEN_HEART_RATE",
  OPEN_BREATHING_RATE: "OPEN_BREATHING_RATE",
  BACK: "BACK",
  OPEN_BP_FORM: "OPEN_BP_FORM",
  OPEN_HR_FORM: "OPEN_HR_FORM",
  OPEN_BREATHING_FORM: "OPEN_BREATHING_FORM",
  BACK_TO_DETAIL: "BACK_TO_DETAIL",
};

export const vitalsCategoryMachine = setup({
  types: {} as { context: Record<string, never> },
}).createMachine({
  id: "vitalsCategory",
  initial: VitalsCategoryState.Dashboard,
  context: {},
  states: {
    [VitalsCategoryState.Dashboard]: {
      on: {
        [vitalsCategoryEventNames.OPEN_BLOOD_PRESSURE]: {
          target: VitalsCategoryState.BloodPressure,
        },
        [vitalsCategoryEventNames.OPEN_HEART_RATE]: {
          target: VitalsCategoryState.HeartRate,
        },
        [vitalsCategoryEventNames.OPEN_BREATHING_RATE]: {
          target: VitalsCategoryState.BreathingRate,
        },
      },
    },
    [VitalsCategoryState.BloodPressure]: {
      on: {
        [vitalsCategoryEventNames.BACK]: {
          target: VitalsCategoryState.Dashboard,
        },
        [vitalsCategoryEventNames.OPEN_BP_FORM]: {
          target: VitalsCategoryState.BloodPressureForm,
        },
      },
    },
    [VitalsCategoryState.BloodPressureForm]: {
      on: {
        [vitalsCategoryEventNames.BACK_TO_DETAIL]: {
          target: VitalsCategoryState.BloodPressure,
        },
      },
    },
    [VitalsCategoryState.HeartRate]: {
      on: {
        [vitalsCategoryEventNames.BACK]: {
          target: VitalsCategoryState.Dashboard,
        },
        [vitalsCategoryEventNames.OPEN_HR_FORM]: {
          target: VitalsCategoryState.HeartRateForm,
        },
      },
    },
    [VitalsCategoryState.HeartRateForm]: {
      on: {
        [vitalsCategoryEventNames.BACK_TO_DETAIL]: {
          target: VitalsCategoryState.HeartRate,
        },
      },
    },
    [VitalsCategoryState.BreathingRate]: {
      on: {
        [vitalsCategoryEventNames.BACK]: {
          target: VitalsCategoryState.Dashboard,
        },
        [vitalsCategoryEventNames.OPEN_BREATHING_FORM]: {
          target: VitalsCategoryState.BreathingRateForm,
        },
      },
    },
    [VitalsCategoryState.BreathingRateForm]: {
      on: {
        [vitalsCategoryEventNames.BACK_TO_DETAIL]: {
          target: VitalsCategoryState.BreathingRate,
        },
      },
    },
  },
});
